import RulesetContext from "../common/ruleset-context";

export default class FootballRulesetContext extends RulesetContext {
    constructor() {
        super();
        this.awardFirstDown = false;
        this.resetField = false;
        this.advanceDown = true;
        this.changeDownApplied = false;
        this.isSafety = false;
        this.isKickoffPenalty = false;
    }

    setResetField(value) {
        this.resetField = value;
    }

    setAwardFirstDown(value) {
        this.awardFirstDown = value;
    }

    setChangeDownApplied(value) {
        this.changeDownApplied = value;
    }

    setIsSafety(value) {
        this.isSafety = value;
    }

    setIsKickoffPenalty(value) {
        this.isKickoffPenalty = value;
    }
}
